import client from './client';
import { cachedGet } from './apiCache';

const users = {
    async getUserList(params = {}) {
        return await client.get('/api/v1/users_site/', {params});
    },
    getresponsibleList(params = {}) {
        const key = `users:responsible:${JSON.stringify(params)}`;
        return cachedGet(key, () => client.get('/api/v1/responsibleList/', {params}), 120000);
    },
    createUser(body) {
        return client.post('/api/v1/users/create/1c/', body);
    },
    getUserById(id) {
        return client.get(`/api/v1/users/${id}/`);
    },
    updateUser(id, body) {
        return client.put(`/api/v1/users/${id}/`, body);
    },
    deleteUser(id) {
        return client.delete(`/api/v1/users/${id}/`);
    },
    updatePhotoUser(id, body) {
        return client.put(`/api/v1/users/upload_photo/${id}/`, body);
    },
    get_user_status() {
        return client.get(`/api/v1/UserWorkStatus/`);
    },
};

export default users;
